export default "__VITE_ASSET__46598a2d__"